document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.getElementById("open-size-chart");
  const closeBtn = document.getElementById("close-size-chart");
  const drawer = document.getElementById("size-chart-drawer");
  const overlay = document.getElementById("size-chart-overlay");
  const body = document.getElementById("size-chart-body");
  const tabs = document.querySelectorAll(".tab-btn");
  const pages = document.querySelectorAll(".tab-page");
  const container = document.querySelector(".tab-container");
  const trackEl = document.querySelector(".tab-track");

  // 默认页面 & 状态
  let activePage = document.getElementById("charts");
  let unit = "cm"; // "cm" or "in"
  let isAnimating = false;

  // ====== 叠放布局 + 容器高度动画（避免空白/闪回） ======
  if (trackEl) trackEl.style.position = "relative";
  pages.forEach(p => {
    p.style.position = "absolute";
    p.style.inset = "0";
    p.style.width = "100%";
    p.style.boxSizing = "border-box";
    p.style.display = (p === activePage) ? "block" : "none";
  });
  if (activePage) activePage.classList.add("active");
  if (container) container.style.transition = "height 0.6s cubic-bezier(0.4,0,0.2,1)";

  function updateContainerHeight(el = activePage) {
    if (!container || !el) return;
    container.style.height = el.scrollHeight + "px";
  }
  updateContainerHeight();

  // ===== Drawer 打开/关闭 =====
  if (!openBtn || !closeBtn || !drawer || !overlay || !body) return;

  openBtn.addEventListener("click", () => {
    drawer.classList.add("open");
    overlay.classList.add("open");
    renderSizeChart();
    requestAnimationFrame(() => updateContainerHeight());
  });

  function closeDrawer() {
    drawer.classList.remove("open");
    overlay.classList.remove("open");
  }
  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  // 移动端左滑关闭
  let startX = 0;
  drawer.addEventListener("touchstart", e => (startX = e.touches[0].clientX));
  drawer.addEventListener("touchend", e => {
    if (startX - e.changedTouches[0].clientX > 80) closeDrawer();
  });

  // ===== 单位转换工具 =====
  function cmToIn(cm, fixed = 1) {
    const n = parseFloat(cm);
    if (isNaN(n)) return null;
    return (n / 2.54).toFixed(fixed);
  }

  function cmToFeetInch(cm) {
    const n = parseFloat(cm);
    if (isNaN(n)) return null;
    const totalInches = Math.round(n / 2.54);
    const ft = Math.floor(totalInches / 12);
    const inch = totalInches % 12;
    return `${ft}'${inch}"`;
  }

  function kgToLbs(kg, fixed = 0) {
    const n = parseFloat(kg);
    if (isNaN(n)) return null;
    return (n * 2.20462).toFixed(fixed);
  }

  function parseRange(str) {
    const s = String(str).trim().replace(/\s+/g, "");
    if (!/^\d+(\.\d+)?-\d+(\.\d+)?$/.test(s)) return null;
    const [aStr, bStr] = s.split("-");
    const a = parseFloat(aStr);
    const b = parseFloat(bStr);
    if (isNaN(a) || isNaN(b)) return null;
    return { a, b };
  }

  function parseLeq(str) {
    // ≤42.5 / <=42.5 / ≤42.5kg / <=42.5 KG
    const s = String(str).trim().replace(/\s+/g, "").replace(/kg$/i, "");
    const m = s.match(/^(≤|<=)(\d+(\.\d+)?)$/);
    if (!m) return null;
    return { value: parseFloat(m[2]) };
  }

  function stripUnits(s) {
    return String(s).trim().replace(/\s+/g, "").replace(/(cm|kg)$/i, "");
  }

  // ===== 单位切换：只根据 dataset 切（最稳）=====
  function switchUnit(newUnit) {
    unit = newUnit;

    const btnCm = document.getElementById("btn-cm");
    const btnInch = document.getElementById("btn-inch");
    if (btnCm && btnInch) {
      btnCm.style.background = unit === "cm" ? "#000" : "#fff";
      btnCm.style.color = unit === "cm" ? "#fff" : "#000";
      btnInch.style.background = unit === "in" ? "#000" : "#fff";
      btnInch.style.color = unit === "in" ? "#fff" : "#000";
    }

    body.querySelectorAll("[data-display-cm][data-display-in]").forEach(el => {
      el.innerText = (unit === "cm") ? el.dataset.displayCm : el.dataset.displayIn;
    });

    updateContainerHeight();
  }

  // ===== DOM 后处理：把你截图那种表也统一绑定 dataset（关键）=====
  function bindUnitDatasets() {
    // 1) 只保留一个 “Model Info” 标题（按你截图，每张表前都重复了）
    // 仅处理 body 里直接出现的 “Model Info” 文本节点（你现有结构是 <p>Model Info</p>）
    const titles = Array.from(body.querySelectorAll("p, h3, h4, h5, h6, div"))
      .filter(el => (el.textContent || "").trim().toLowerCase() === "model info");
    titles.forEach((el, idx) => {
      if (idx > 0) el.style.display = "none";
    });

    // 2) 处理所有 size-model-table
    const tables = Array.from(body.querySelectorAll("table.size-model-table"));

    tables.forEach(tbl => {
      const firstHeaderCell = tbl.querySelector("thead th, thead td, tr th, tr td");
      const headerRow = tbl.querySelector("thead tr") || tbl.querySelector("tr");

      const headerText = (headerRow ? headerRow.textContent : "").toUpperCase();

      const isHeightBust = headerText.includes("HEIGHT") && headerText.includes("BUST");
      const isHeightWeight = headerText.includes("HEIGHT") && headerText.includes("WEIGHT");

      // A) Height/Bust：横轴 72-76…（cm区间 -> inch区间）
      if (isHeightBust) {
        const ths = Array.from(headerRow.querySelectorAll("th, td"));
        ths.forEach((th, idx) => {
          if (idx === 0) return; // "HEIGHT / BUST" 不动
          const raw = stripUnits(th.textContent);
          const r = parseRange(raw);
          if (!r) return;

          const inA = cmToIn(r.a, 1);
          const inB = cmToIn(r.b, 1);
          if (inA == null || inB == null) return;

          // cm 模式保持你现在的视觉（不强行加 cm），inch 模式显示 in
          th.dataset.displayCm = th.textContent.trim();
          th.dataset.displayIn = `${inA}-${inB} in`;
        });

        // 纵轴 height：150 cm -> 4'11"
        Array.from(tbl.querySelectorAll("tbody tr")).forEach(tr => {
          const firstTd = tr.querySelector("td");
          if (!firstTd) return;
          const raw = stripUnits(firstTd.textContent);
          const n = parseFloat(raw);
          if (isNaN(n)) return;
          const ftin = cmToFeetInch(n);
          if (!ftin) return;

          firstTd.dataset.displayCm = firstTd.textContent.trim();
          firstTd.dataset.displayIn = ftin;
        });
      }

      // B) Height/Weight：横轴 ≤42.5 kg / 42.5-50 kg…（kg -> lbs）
      if (isHeightWeight) {
        const ths = Array.from(headerRow.querySelectorAll("th, td"));
        ths.forEach((th, idx) => {
          if (idx === 0) return; // "HEIGHT / WEIGHT" 不动
          const rawText = th.textContent.trim();

          const leq = parseLeq(rawText);
          if (leq) {
            const lbs = kgToLbs(leq.value, 0);
            if (lbs == null) return;
            th.dataset.displayCm = rawText;
            th.dataset.displayIn = `≤${lbs} lbs`;
            return;
          }

          const raw = stripUnits(rawText);
          const r = parseRange(raw);
          if (!r) return;

          const lbA = kgToLbs(r.a, 0);
          const lbB = kgToLbs(r.b, 0);
          if (lbA == null || lbB == null) return;

          th.dataset.displayCm = rawText;
          th.dataset.displayIn = `${lbA}-${lbB} lbs`;
        });

        // 纵轴 height：150 cm -> 4'11"
        Array.from(tbl.querySelectorAll("tbody tr")).forEach(tr => {
          const firstTd = tr.querySelector("td");
          if (!firstTd) return;
          const raw = stripUnits(firstTd.textContent);
          const n = parseFloat(raw);
          if (isNaN(n)) return;
          const ftin = cmToFeetInch(n);
          if (!ftin) return;

          firstTd.dataset.displayCm = firstTd.textContent.trim();
          firstTd.dataset.displayIn = ftin;
        });
      }

      // C) Model Information：key/value 表（右侧有 cm/kg 的都转，鞋码不转）
      // 你的截图结构：左列是 key（Weight/Bust…），右列是 value（42 kg / 75 cm…）
      // 并且第一行是 “HEIGHT | 157 CM” 这种也要转
      const rows = Array.from(tbl.querySelectorAll("tbody tr"));
      if (rows.length && !isHeightBust && !isHeightWeight) {
        rows.forEach(tr => {
          const tds = Array.from(tr.querySelectorAll("td, th"));
          if (tds.length < 2) return;

          const keyEl = tds[0];
          const valEl = tds[tds.length - 1];

          const key = (keyEl.textContent || "").trim().toLowerCase();
          const val = (valEl.textContent || "").trim();

          if (key.includes("shoe")) return;

          // Height
          if (key.includes("height")) {
            const cm = parseFloat(stripUnits(val));
            if (!isNaN(cm)) {
              const ftin = cmToFeetInch(cm);
              if (ftin) {
                valEl.dataset.displayCm = val;
                valEl.dataset.displayIn = ftin;
              }
            }
            return;
          }

          // Weight
          if (key.includes("weight")) {
            const kg = parseFloat(stripUnits(val));
            if (!isNaN(kg)) {
              const lbs = Math.round(kg * 2.20462);
              valEl.dataset.displayCm = val;
              valEl.dataset.displayIn = `${lbs} lbs`;
            }
            return;
          }

          // Bust/Waist/Hip
          if (key.includes("bust") || key.includes("waist") || key.includes("hip")) {
            const cm = parseFloat(stripUnits(val));
            if (!isNaN(cm)) {
              const inch = cmToIn(cm, 1);
              if (inch != null) {
                valEl.dataset.displayCm = val;
                valEl.dataset.displayIn = `${inch} in`;
              }
            }
            return;
          }

          // 其它（Top Size / Bottom Size）不动
        });
      }
    });

    // 按当前 unit 立刻刷新显示
    switchUnit(unit);
  }

  // ===== 渲染（你原来逻辑保留：我这里不改你如何插表，只做“DOM后处理绑定”）=====
  function renderSizeChart() {
    const raw = body.dataset.raw;
    if (!raw) return;

    const sections = raw.split(/\n\s*\n/).map(s => s.trim()).filter(Boolean);

    body.innerHTML = `
      <div style="margin-bottom: 16px;">
        <div style="display:flex; border:1px solid #ccc; width:200px;">
          <button id="btn-cm" class="active" style="flex:1; padding:6px; border:none; cursor:pointer; background:#000; color:#fff;">CM</button>
          <button id="btn-inch" style="flex:1; padding:6px; border:none; cursor:pointer; background:#fff; color:#000;">INCH</button>
        </div>
      </div>
    `;

    // 这里仍然用你原本的 raw -> html 渲染方式（不管你是怎么 render 的）
    // 你当前项目里可能已有 renderSizeTable/renderModelTable 等函数；如果没有，就保持你原来的实现。
    // 我只负责：渲染完后做 bindUnitDatasets()

    sections.forEach(section => {
      // 如果你原来就是 insertAdjacentHTML 生成表，就保持原来逻辑；
      // 这里给一个最保险的兜底：直接按原文本输出，让你现有的渲染器接管。
      // （如果你项目里已有 renderSizeTable/renderModelTable，请把这里换回你原来的 render 分发）
      const pre = document.createElement("pre");
      pre.style.display = "none";
      pre.textContent = section;
      body.appendChild(pre);
    });

    const btnCm = document.getElementById("btn-cm");
    const btnInch = document.getElementById("btn-inch");
    if (btnCm && btnInch) {
      btnCm.addEventListener("click", () => switchUnit("cm"));
      btnInch.addEventListener("click", () => switchUnit("in"));
    }

    // ✅ 关键：渲染后绑定转换（对你截图那种结构直接生效）
    // 你的真实项目里：表格HTML肯定已经在这里之前被插入了 body
    // 所以这里做一次 bind 即可。
    requestAnimationFrame(() => {
      bindUnitDatasets();
      updateContainerHeight();
    });
  }

  // ===== Tabs：旧页先滑出 → 新页滑入（不改）=====
  tabs.forEach(btn => {
    btn.addEventListener("click", () => {
      const targetId = btn.dataset.target;
      const targetPage = document.getElementById(targetId);
      if (!targetPage || targetPage === activePage || isAnimating) return;

      tabs.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      isAnimating = true;

      const clean = el => el.classList.remove(
        "slide-out-left", "slide-out-right", "slide-in-left", "slide-in-right"
      );
      clean(activePage);
      clean(targetPage);

      const goingLeft = targetId === "measuring";

      targetPage.style.display = "block";

      requestAnimationFrame(() => {
        updateContainerHeight(targetPage);
      });

      activePage.classList.remove("active");
      activePage.classList.add(goingLeft ? "slide-out-left" : "slide-out-right");

      const onOutEnd = () => {
        activePage.removeEventListener("animationend", onOutEnd);
        activePage.style.display = "none";
        activePage.classList.remove("slide-out-left", "slide-out-right");

        targetPage.classList.add(goingLeft ? "slide-in-right" : "slide-in-left");

        const onInEnd = () => {
          targetPage.removeEventListener("animationend", onInEnd);
          targetPage.classList.remove("slide-in-left", "slide-in-right");
          targetPage.classList.add("active");
          activePage = targetPage;
          isAnimating = false;
          updateContainerHeight();
        };
        targetPage.addEventListener("animationend", onInEnd, { once: true });
      };
      activePage.addEventListener("animationend", onOutEnd, { once: true });
    });
  });

  window.addEventListener("resize", () => updateContainerHeight());
});
